import { Alert, Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { TaskDetail } from 'modules/tasks/components/TaskElement/useTaskDetail'
import { TaskIdentifier } from 'modules/tasks/lib/task'

import { useShareTaskProvider } from '../Provider'
import { Add } from './Add'
import { EmployeeList } from './EmployeeList'

interface Props {
  task: TaskDetail
  onClose: () => void
}

export const ShareTaskModal = ({ task, onClose }: Props) => {
  const { loading, saveChanges, accessesToRemove, addedSharedAccesses, currentSharedAccesses } =
    useShareTaskProvider()

  const editorsNumber = () => {
    const assignees = task.assignees.filter((item) => item.id !== task?.author?.id)

    return assignees.length + 1 // Assignes plus the author
  }

  const sharedAccessesNumber = () => {
    return addedSharedAccesses.filter((i) => !accessesToRemove.includes(i)).length
  }

  const trackSubmit = () => {
    if (addedSharedAccesses.length != currentSharedAccesses.length || accessesToRemove.length > 0) {
      track(trackingEvents.tasks.shareTaskSaved, {
        task_id: task.id,
        editorsNumber: editorsNumber(),
        sharedAccessesNumber: sharedAccessesNumber(),
        fromProject: task.identifier === TaskIdentifier.Project,
      })
    }
  }

  const Footer = (
    <Box flexDirection="row" justifyContent="flexEnd" gap="s8">
      <Button type="secondary" onClick={onClose}>
        {i18n.t('common.cancel')}
      </Button>
      <Button
        type="primary"
        disabled={loading}
        onClick={() => {
          saveChanges()
          trackSubmit()
          onClose()
        }}
      >
        {i18n.t('common.save')}
      </Button>
    </Box>
  )

  return (
    <Modal
      illustration="add-user"
      title={i18n.t('tasks.share.modal.title', { taskName: task?.name })}
      description={i18n.t('tasks.share.modal.description')}
      onClose={onClose}
      footer={Footer}
    >
      <Box gap="s24">
        <Alert color="info">
          <Text.Normal>{i18n.t('tasks.share.modal.info')}</Text.Normal>
        </Alert>

        <Add task={task} />

        <EmployeeList task={task} />
      </Box>
    </Modal>
  )
}
